import { render, staticRenderFns } from "./ExpansionPanelHeader.vue?vue&type=template&id=53ab3b38&scoped=true"
import script from "./ExpansionPanelHeader.vue?vue&type=script&lang=js"
export * from "./ExpansionPanelHeader.vue?vue&type=script&lang=js"
import style0 from "./ExpansionPanelHeader.vue?vue&type=style&index=0&id=53ab3b38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ab3b38",
  null
  
)

export default component.exports